// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__mIt2h","contact":"Contact_contact__F4oKl"};